import { QueryClient, DefaultOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

const queryConfig: DefaultOptions = {
  queries: {
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
    retry: (failureCount, error) => {
      if (error instanceof AxiosError) {
        // Don't retry on 4xx errors (client errors)
        if (error.response?.status && error.response.status >= 400 && error.response.status < 500) {
          return false;
        }
      }
      // Retry up to 3 times for other errors
      return failureCount < 3;
    },
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  },
  mutations: {
    retry: false,
  },
};

export const queryClient = new QueryClient({
  defaultOptions: queryConfig,
});

// Query keys factory for better organization
export const queryKeys = {
  all: ['api'] as const,
  waitlist: {
    all: () => [...queryKeys.all, 'waitlist'] as const,
    status: (email: string) => [...queryKeys.waitlist.all(), 'status', email] as const,
  },
  auth: {
    all: () => [...queryKeys.all, 'auth'] as const,
    user: () => [...queryKeys.auth.all(), 'user'] as const,
  },
} as const;